import { Component, Input } from '@angular/core';
import { Dashboard } from '../../models/dashboard.model';
import { Placeholder } from '../../models/placeholder.model';
import { ThresholdChartData } from '../../models/threshold-chart-data.model';

@Component({
    selector: 'app-long-threshold-chart',
    templateUrl: './long-threshold-chart.component.html',
    styleUrls: ['./long-threshold-chart.component.css']
})
export class LongThresholdChartComponent {

    @Input() dashboard: Dashboard;

    @Input() data: ThresholdChartData[] = [];

    @Input() locale: string;

    get placeholders(): Placeholder[] {
        return [
            Placeholder.create("currencyCode", this.dashboard.getCurrencyCode()),
        ];
    }

}
